export default __webpack_public_path__ + "static/media/GroupPhoto1.a9860793.png";